import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import { UrlBuilderService } from '../../common/services/url-builder.service';
import { WidgetConfiguration } from '../models/widget-configuration';

@Injectable()
export class WidgetConfigurationsService {

  constructor(
    private urlBuilder: UrlBuilderService,
    private http: HttpClient) { }

  getAll(product: string): Observable<WidgetConfiguration[]> {
    const widgetConfigsUrl = this.urlBuilder.getUrl('widgetconfigs');
    const params = new HttpParams().set('product', product);
    return this.http
      .get<WidgetConfiguration[]>(widgetConfigsUrl, { params: params })
      .pipe(map(configs => configs || []));
  }

  getForDashboard(dashboardIdentifier: string): Observable<WidgetConfiguration[]> {
    const widgetConfigsUrl = this.urlBuilder.getUrl(dashboardIdentifier + '/widgetconfigs');
    return this.http
      .get<WidgetConfiguration[]>(widgetConfigsUrl).pipe(
        map(configs => configs || [])
      );
  }

  getAllForDashboardAndProfile(dashboardIdentifier: string, profileId: number) {
    const widgetConfigsUrl = this.urlBuilder.getUrl('profiledashboardwidgetconfigs');
    const params = new HttpParams()
      .set('dashboardIdentifier', dashboardIdentifier)
      .set('profileId', profileId.toString());
    return this.http
      .get<WidgetConfiguration[]>(widgetConfigsUrl, { params: params }).pipe(
        map(configs => configs || [])
      );
  }

  save(config: WidgetConfiguration) {
    const widgetConfigsUrl = this.urlBuilder.getUrl('widgetconfigs/save');
    return this.http.post(widgetConfigsUrl, config);
  }

  createcopy(config: WidgetConfiguration) {
    const widgetConfigsUrl = this.urlBuilder.getUrl('widgetconfigs/createcopy');
    return this.http.post(widgetConfigsUrl, config);
  }

  delete(config: WidgetConfiguration) {
    const widgetConfigsUrl = this.urlBuilder.getUrl('widgetconfigs/delete');
    return this.http.post(widgetConfigsUrl, config);
  }
}
